import { BoardListPositionSelectSkeleton } from './BoardListPositionSelectSkeleton';

export const MoveCardPopoverSkeleton = () => {
  return <BoardListPositionSelectSkeleton />;
};
